import * as core from '../../../../../../../core'
import * as changeImpacts from '../change-impacts'

export const RESOURCE = {
  payload: {
    alias: 'change.impact.log',
    appAlias: changeImpacts.RESOURCE.payload.alias,
    description: 'View the log of change impacts for this client',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Change Impact Log',
    page: { alias: 'change.impact.log' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
